import { html } from 'lit';

export const addFolderIcon = ({
  onClick,
  color = '#0099ff',
  height,
}: { onClick?: () => void; color?: string; height?: string } = {}) =>
  html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      @click=${() => onClick?.()}
      style=${`cursor: pointer; width: fit-content; height: ${height ?? '24px'}; fill: ${color ?? 'currentColor'};`}
    >
      <path
        d="M3 5C3 3.89543 3.89543 3 5 3H9C9.55229 3 10.0796 3.30536 10.3756 3.78297L11.4142 5.5H19C20.1046 5.5 21 6.39543 21 7.5V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V5Z"
      />
      <path
        d="M12 10C12 9.44772 12.4477 9 13 9H13.01C13.5623 9 14.01 9.44772 14.01 10C14.01 10.5523 13.5623 11 13.01 11H13C12.4477 11 12 10.5523 12 10Z"
      />
      <path
        d="M16 10C16 9.44772 16.4477 9 17 9H17.01C17.5623 9 18.01 9.44772 18.01 10C18.01 10.5523 17.5623 11 17.01 11H17C16.4477 11 16 10.5523 16 10Z"
      />
      <path
        d="M12 14C12 13.4477 12.4477 13 13 13H17C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15H13C12.4477 15 12 14.5523 12 14Z"
      />
      <path
        d="M15 17C15 16.4477 15.4477 16 16 16C16.5523 16 17 16.4477 17 17V17.01C17 17.5623 16.5523 18.01 16 18.01C15.4477 18.01 15 17.5623 15 17.01V17Z"
      />
      <!-- Plus-Kreis oben rechts -->
      <circle cx="18" cy="6" r="3.5" fill="#ffffff" />
      <path
        d="M18 4C18.2761 4 18.5 4.22386 18.5 4.5V7.5C18.5 7.77614 18.2761 8 18 8C17.7239 8 17.5 7.77614 17.5 7.5V4.5C17.5 4.22386 17.7239 4 18 4Z"
        fill=${color ?? 'currentColor'}
      />
      <path
        d="M16 6C16 5.72386 16.2239 5.5 16.5 5.5H19.5C19.7761 5.5 20 5.72386 20 6C20 6.27614 19.7761 6.5 19.5 6.5H16.5C16.2239 6.5 16 6.27614 16 6Z"
        fill=${color ?? 'currentColor'}
      />
    </svg>
  `;
